import { useEffect, useState } from 'react'
import { store } from '@src/store'
import { Wallet } from '@src/reducers/wallet.reducer'
import { AttentionPoint } from './components/AttentionPoint'

export function SpecialBonusAttention({ me }) {
  const [gamblerWallet, setGamblerWallet] = useState<Wallet>()
  const [show, setShow] = useState(false)
  const [specialBonusData, setSpecialBonusData] = useState<any>(null)
  const pendingKycBonuses = me?.pendingKycBonuses ?? []
  const hasPendingKycBonuses = pendingKycBonuses.length > 0

  useEffect(() => {
    const getBonusData = () => {
      if (me && store.getState().wallet.wallets.length > 0) {
        const gamblerWalletData = store.getState().wallet.wallets.find((w) => !!w.campaign?.meta?.playable)
        setGamblerWallet(gamblerWalletData)
        const specialBonus =
          hasPendingKycBonuses || !!gamblerWalletData
            ? {
                balance: gamblerWalletData?.balance || (pendingKycBonuses[0]?.amount ?? 0),
                currency: gamblerWalletData?.currency || (pendingKycBonuses[0]?.currency ?? 'BTC'),
              }
            : null
        setSpecialBonusData(specialBonus)
      }
    }
    const unsubscribe = store.subscribe(getBonusData)
    getBonusData()

    return () => unsubscribe()
  }, [, store.getState().wallet])

  useEffect(() => {
    if (gamblerWallet) {
      const multiplier = gamblerWallet.campaign?.payoutMultiplyer || 1
      const amount = gamblerWallet.campaign?.userInCampaign?.amount || 0
      const wagered = gamblerWallet.campaign?.userInCampaign?.betSum ?? 0
      const toBeWagered = multiplier * amount
      const progress = (wagered / toBeWagered) * 100
      const win = progress >= 100
      setShow(win && specialBonusData)
    }
  }, [gamblerWallet])

  return show ? <AttentionPoint type="bonus" /> : <></>
}
